import VehiclesError from './VehiclesError.js'

export default class GetModelsGroupedByBodyTypeDoorsVehiclesError extends VehiclesError {}
